<style lang="scss">
    .ivu-select-multiple .ivu-tag{
        height: inherit !important;
        line-height: inherit !important;
        padding: 3px 8px 6px;
    }
    .hidefooter .ivu-modal-footer {
        display: block !important;
    }
    .searchb2c textarea.ivu-input{
        font-size: 12px
    }
</style>

<template>
    <div class="search-wrap searchb2c">
        <article class="search-main clearfix">
            <div class="pull-left">
                <Form :label-width="80" inline>
                    <FormItem label='订单号'>
                        <Input v-model="formData.EQ_orderNo" style="width:200px;" placeholder="同时支持订单序号/订单号查询"></Input>
                    </FormItem>
                    <FormItem label='订单类型' >
                        <Select v-model="formData.IN_orderType" filterable multiple :max-tag-count="2" style="width:200px;">
                            <Option v-for="item in ordertypeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label='组织' >
                        <Select v-model="formData.IN_orgId" filterable multiple :max-tag-count="2" style="width:200px;">
                            <Option v-for="item in getOrgList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                </Form>
            </div>
            <div class="pull-right">
                <Form inline>
                    <Button type="primary" @click="update(true)" icon="ios-search">查询</Button>
                    <Button @click="resetdata" icon='md-refresh'>重置</Button>
                    <Button type="dashed" @click="isOpen=!isOpen">更多查询<Icon type="ios-arrow-down" class="margin-left-5"></Icon></Button>
                </Form>
            </div>
        </article>
        <transition >
            <div v-show="isOpen">
                <Form class="search-other" :label-width="80" inline >
                    <FormItem label='渠道' >
                        <Select v-model="formData.IN_channelId" filterable multiple :max-tag-count="2" style="width:200px;">
                            <Option v-for="item in accountsAll" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label='项目' >
                        <Select v-model="formData.IN_lineId" filterable multiple :max-tag-count="2" style="width:200px;">
                            <Option v-for="item in getNewAllProductList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem label='创建时间'>
                        <DatePicker type="daterange"
                                    :options="options"
                                    placement="bottom-end"
                                    placeholder="Select date"
                                    style="width:200px;"
                                    ref="createdAt"
                                    :value="getdate"
                                    @on-change="createTime"
                        ></DatePicker>
                    </FormItem>
                </Form>
            </div>
        </transition>
        <transition>
            <Form inline class="search-other">
                <Button type="warning" class="margin-right-5" @click="handleModal('backnormal')">恢复正常</Button>
                <Button type="primary" class="margin-right-5" @click="handleModal('addnotes')">添加备注</Button>
            </Form>
        </transition>
    </div>
</template>

<script>
    import { mapState,mapGetters} from "vuex";

    export default {
        data() {
            return {
                SYSID:'',
                aaaa:"",
                isOpen: false,
                getdate:[],
                getshipdate:[],
                routerName:this.$route.name,
                states:[],
                formData:{

                    IN_orgId:'',
                    IN_lineId:'',
                    NE_orgId:2,
                    IN_channelId:'',
                    EQ_orderNo:'',
                    IN_orderType:'',
                    GE_createdAt:'',
                    LE_createdAt:'',
                    EQ_errorCode:'carrierException'
                },
                options: {
                    shortcuts: [
                        {text: '最近一周',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
                                return [start, end];
                            }
                        },
                        {text: '最近一月',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
                                return [start, end];
                            }
                        },
                        {text: '最近一季度',
                            value () {
                                const end = new Date();
                                const start = new Date();
                                start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
                                return [start, end];
                            }
                        }
                    ]
                },
                // 订单类型
                ordertypeList:[
                    { value: 'normally',label: '正常销售' },
                    { value: 'celebrity',label: '展示订单' },
                    { value: 'distribution',label: '分销订单' },
                    { value: 'brush',label: '刷评订单' },
                    { value: 'DELIVERY',label: '发货订单' },
                ],
            };
        },
    created() {
        let b2cflag = localStorage.get('b2cflag')
        if(!b2cflag){
            this.getdate = []
            this.getshipdate = []
        }
    },
    mounted(){
        this.update();
    },
    computed: {
        ...mapGetters('diction',['getNewAllProductList','getNewAllAccountIdList']),
        ...mapGetters('dictionary', ['getOrgList','getNewAllWarehouseIdList']),
        warehousesAll(){
            return this.getNewAllWarehouseIdList.filter(function(item){
                return item.attach.warehouseType !== 4
            })
        },
        accountsAll(){
            return this.getNewAllAccountIdList.sort(function(a,b){
                return a.label.localeCompare(b.label)
            })
        },
        propsData(){
            return [
                
                {label:this.$t('erp.b2c.search_ordernumber',{defaultValue:'订单号'}),key:'EQ_orderNo'},
                {label:this.$t('erp.b2c.search_ordertype',{defaultValue:'订单类型'}),key:'IN_orderType',tag:'Select',value:this.ordertypeList,props:'multiple'},
                {label:this.$t('global.common.organization',{defaultValue:'组织'}),key:'IN_orgId',tag:'Select',value:this.getOrgList},
                {label:this.$t('global.common.channel',{defaultValue:'渠道'}),key:'IN_channelId',tag:'Select',value:this.accountsAll,props:'multiple'},
                {label:this.$t('global.common.line',{defaultValue:'项目'}),key:'IN_lineId',tag:'Select',value:this.getNewAllProductList,props:'multiple'},
                {label:this.$t('global.common.createdtime',{defaultValue:'创建时间'}),key:['GE_createdAt','LE_createdAt'],tag:'timearray'},
                
            ]
        },
    },
    methods: {


        handleModal(type,id) {
            this.$parent.handleOperates(id,type)
        },

        update(type,parms){
            console.log(this.formData.GE_createdAt)
            if(this.formData.GE_createdAt == ""){
                this.getdate = []
            }
            this.$emit('on-update', { search: {...this.formData}, page: 1 });
        },

        resetdata(){
            this.formData = {
                IN_orgId:'',
                IN_lineId:'',
                NE_orgId:2,
                IN_channelId:'',
                EQ_orderNo:'',
                IN_orderType:'',
                GE_createdAt:'',
                LE_createdAt:'',
                EQ_errorCode: 'carrierException',
            };
            this.getdate = [];
            this.$emit('on-update', {
                    search: {
                        ...this.formData
                },
                page: 1
        });
        },

        createTime(data){
            this.formData.GE_createdAt = data[0]
            this.formData.LE_createdAt = data[1]
        },
    },
    };
</script>
